import TransferPageBody from "./TransferPageBody"
import { useParams } from "react-router-dom"

export default function TransferPage() {
  const { transfer_id } = useParams()

  return(
    <div className="flex flex-col overflow-y-auto w-full grow lg:justify-center">
      <TransferPageBody transferId={transfer_id} />
    </div>
  )
}